var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { makeObservable, observable, action, runInAction } from 'mobx';
import { ModelCategoryTag } from '~/models';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { ServiceCommunity } from '~/services/service.community';
export let ServiceCategoryTag = class ServiceCategoryTag extends BaseSingletonService {
    communityService;
    tags = [];
    categoryId;
    communityId;
    constructor(communityService) {
        super();
        this.communityService = communityService;
        makeObservable(this);
    }
    setCategoryId(categoryId) {
        this.categoryId = categoryId;
    }
    getItems(tags) {
        return tags?.map(tag => ({
            label: tag.name,
            value: tag.id,
        }));
    }
    getTags(params) {
        const url = this.categoryId
            ? `${EApiUrl.communities}/${this.communityService.currentCommunity.id}/categories/${this.categoryId}/${EApiUrl.tags}`
            : `${EApiUrl.communities}/${this.communityService.currentCommunity.id}/categories/${EApiUrl.tags}`;
        return new MobxQuery({
            queryFn: (() => api
                .get(url, { params })
                .then(response => {
                runInAction(() => (this.tags = this.getItems(plainToInstance(ModelCategoryTag, response.data))));
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceCategoryTag.prototype, "tags", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ServiceCategoryTag.prototype, "getTags", null);
ServiceCategoryTag = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof ServiceCommunity !== "undefined" && ServiceCommunity) === "function" ? _a : Object])
], ServiceCategoryTag);
